import { Pipe, PipeTransform } from '@angular/core';
import { Controller } from 'src/app/core/models/controller.model';
import { Property } from 'src/app/core/models/project/property.model';

@Pipe({
  name: 'getRelayOutputName'
})
export class GetRelayOutputNamePipe implements PipeTransform {

  transform(controllers: Controller[], outputStatusNumber: string): string {

      const byRentedProps: Property[] = [];
      const forcedOnProps: Property[] = [];
      const forcedOffProps: Property[] = [];
      const autoModeProps: Property[] = [];
      const inCoolingProps: Property[] = [];

      controllers.forEach((cont)=> {
        cont.controllerProperties.$values.forEach((prop)=> {
          if (!prop.mqttTopic.endsWith(outputStatusNumber)) {
            return
           }

          if (Property.isRelayOutputByRentedOrPresence(prop) ) {
            byRentedProps.push(prop)
          } else if (Property.isRelayOutputForceOn(prop) ) {
            forcedOnProps.push(prop)
          } else if (Property.isRelayOutputForceOff(prop) ) {
            forcedOffProps.push(prop)
          } else if (Property.isRelayOutputAutoMode(prop) ) {
            autoModeProps.push(prop)
          } else if (Property.isRelayOutputInCooling(prop) ) {
            inCoolingProps.push(prop)
          }
        })
      })

      if (forcedOnProps.length>0) {
        return forcedOnProps[0].name.split('|')[0]
      } else if (forcedOffProps.length>0) {
        return forcedOffProps[0].name.split('|')[0]
      }else if (byRentedProps.length>0) {
        return byRentedProps[0].name.split('|')[0]
      } else if (autoModeProps.length>0){
        return autoModeProps[0].name.split('|')[0]
      } else if (inCoolingProps.length>0){
        return inCoolingProps[0].name.split('|')[0]
      } else {
        return '';
      }
  }

}
